module.exports = __webpack_public_path__ + "img/platform.045a4b1.png";